import { dapiFetchCache, IDapiCacheRequest } from "@origin-digital/daxi";
import type { IUserContext } from "@origin-digital/event-dispatcher";
import { EnvironmentNames } from "@origin-digital/platform-enums";
import { IServiceStatusResponse } from "./enrichUserContext";

const API_GATEWAY_HOST: Record<EnvironmentNames, string> = {
  dev: "https://api-dev.rx.originenergy.com.au",
  local: "https://api-dev.rx.originenergy.com.au",
  prod: "https://api.rx.originenergy.com.au",
  staging: "https://api-test.rx.originenergy.com.au",
  test: "https://api-test.rx.originenergy.com.au",
  regress: "https://api-test.rx.originenergy.com.au",
};
const DEFAULT_AUTH_CACHE_REQUEST: IDapiCacheRequest = {
  authorization: "jwt",
  ttlInMin: 30,
  allowStaleData: true,
};
const USER_PATH = "/api/appcontext/v3/user";
const SERVICE_STATUS_PATH = "/account/kraken/service/status";

export const fetchKrakenServiceStatuses = async (
  backendServiceIds: string[]
): Promise<IServiceStatusResponse | undefined> => {
  try {
    const environment = window.oetal.env.name as EnvironmentNames;
    const { data } = await dapiFetchCache<{ data?: IServiceStatusResponse }>(
      SERVICE_STATUS_PATH,
      {
        ...DEFAULT_AUTH_CACHE_REQUEST,
        host: API_GATEWAY_HOST[environment],
        method: "POST",
        body: {
          backendServiceIds,
        },
      }
    );
    return data?.data;
  } catch {
    // Note this will error for all unauthenticated users (expected)
    throw new Error("Could not fetch Kraken service statuses");
  }
};

export const fetchUserContextV3 = async (): Promise<
  IUserContext | undefined
> => {
  try {
    const res = await dapiFetchCache<IUserContext>(
      USER_PATH,
      DEFAULT_AUTH_CACHE_REQUEST
    );

    return res.data;
  } catch {
    // Note this will error for all unauthenticated users (expected)
    throw new Error("Could not fetch user context");
  }
};
